// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__vfNj6","rootSuccess":"CompleteLink_rootSuccess__3xMfQ","rootFailure":"CompleteLink_rootFailure__38aIA","isDisabled":"CompleteLink_isDisabled__2QTPs"};